import { h } from 'preact'
import styled from 'styled-components'
import { colors, transition } from '../../constants'

import * as svgs from '../svgs'
import TooltipBubble from '../TooltipBubble'
import hoverDisabler from '../hoverDisabler'
import { PieChart, ActivityChart } from './Charts'

const fullfillmentToCategory = f => {
  if (!f || f === '0') return 'nopledge'
  const fullfillment = typeof f === 'string' && f.toLowerCase()
  if (Number.isFinite(Number(fullfillment))) return 'fail'
  return (
    {
      '': 'nopledge',
      'plní slib': 'ok',
      nepřítomen: 'notpresent',
      nehlasoval: 'didnotvote',
      nehlasovalo: 'novoteyet',
      slíbil: 'novotepledge',
      schváleno: 'ratifiedPreMandate',
      nehodnoceno: 'noVoteRatifed',
    }[fullfillment] || 'failtext'
  )

  /*
   & = panáček
   * měl mandát - grafy ano
      *
        * grey  nezavázal se ""
        * red   porušil slib number
        * green drží slib "plní slib"
        * grey  Nezúčastnil se žádného hodnoceného hlasování //  "nepřítomen"

    * neměl mandát - hodnotíme, grafy ne
      *
        * grey  Neměl příležitost hlasovat (v rámci svého madnátu)  "nehlasoval"
        * green Příslíbil podporu &, ale zatím neměl příležitost hlasovat. "slíbil"
        * grey  Schváleno před začátkem tohoto mandátu "schváleno"
        * grey  Nedošlo k žádnému hodnotitelnému hlasování "nehodnoceno"
  */
}

const fullfillmentToText = (fullfillment, gender, panacek = true) =>
  ({
    fail: (
      <span>
        {fullfillment}x porušil{gender === 'M' ? '' : 'a'} slib{panacek && <svgs.PanacekNoSupport />}
      </span>
    ),
    nopledge: <span>Neslíbil{gender === 'M' ? '' : 'a'} podporu</span>,
    ok: <span>Drží slib {panacek && <svgs.PanacekBlack />}</span>,
    notpresent: (
      <span>
        Nezúčastnil{gender === 'M' ? '' : 'a'} se žádného hodnoceného hlasování
      </span>
    ),

    didnotvote: (
      <span>Neměl{gender === 'M' ? '' : 'a'} příležitost hlasovat.</span>
    ),
    novoteyet: 'O tomto restu se ještě nehlasovalo.',
    novotepledge: (
      <span>
        Přislíbil{gender === 'M' ? '' : 'a'} podporu{panacek && ' '}
        {panacek && <svgs.PanacekBlack />}, ale zatím neměl{gender === 'M' ? '' : 'a'}{' '}
        příležitost hlasovat.
      </span>
    ),
    ratifiedPreMandate: 'Schváleno před začátkem mandátu',
    noVoteRatifed: 'Nedošlo k žádnému hodnotitelnému hlasování',
  }[fullfillmentToCategory(fullfillment)])

const fullfillmentToColor = fullfillment =>
  ({
    fail: colors.red,
    nopledge: colors.middleGrey,
    ok: colors.green,
    notpresent: colors.middleGrey,
    didnotvote: colors.middleGrey,
    nehlasovalo: colors.middleGrey,
    novotepledge: colors.green,
    ratifiedPreMandate: colors.middleGrey,
    noVoteRatifed: colors.middleGrey,
  }[fullfillmentToCategory(fullfillment)])

const RestTabInner = styled.div`
  cursor: pointer;
  text-align: center;
  padding: 7px 0;
  background-color: ${props =>
    props.isSelected ? colors.darkGrey : colors.grey};
  color: ${props => props.isSelected && 'white'};
  opacity ${props => props.opacity};
`

const RestTabTriangle = styled.div`
  border-top: 11px solid ${colors.darkGrey};
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  width: 20px;
  position: absolute;
  left: 50%;
  margin-left: -10px;
  opacity: ${props => props.opacity};
`

const RestTabOuter = hoverDisabler(styled.div`
  width: ${props => (props.small ? '20%' : '10%')};
  display: inline-block;
  padding: 0 4px;
  margin: 0 0 15px 0;

  font-size: 16px;
  font-weight: bold;
  position: relative;
  ${TooltipBubble} {
    pointer-events: none;
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
    left: 50%;
    position: absolute;
  }

  :hover ${TooltipBubble} {
    opacity: ${props => (props.hoverDisable ? 0 : 1)};
  }
  :hover ${RestTabTriangle} {
    border-top: 11px solid black;
  }
  :hover ${RestTabInner} {
    background-color: black;
    color: white;
  }
`)

const RestTab = props => {
  const { no, isSelected, comment, name, gender, small } = props
  const tabState = `${props.tabState}`.toLowerCase()

  const opacity =
    {
      novote: 0.5,
      preMandate: 0.5,
      novotepledge: 0.5,
    }[fullfillmentToCategory(tabState)] || 1

  return (
    <RestTabOuter small={small}>
      <TooltipBubble
        width={450}
        offset={
          small
            ? {
                0: 0.1,
                1: 0.305,
                3: 0.69,
                4: 0.9,
                5: 0.1,
                6: 0.305,
                8: 0.69,
                9: 0.9,
              }[no] || 0.5
            : {
                0: 0.1,
                1: 0.305,
                8: 0.69,
                9: 0.9,
              }[no] || 0.5
        }
      >
        <div style={{ fontSize: '1em' }}>{no ? name : 'Všechny zákony'}</div>
        <div style={{ color: fullfillmentToColor(tabState) }}>
          {fullfillmentToText(tabState, gender, false)}
        </div>
        <div style={{ fontSize: '.85em', lineHeight: '1.5em' }}>
          {comment || ''}
        </div>
      </TooltipBubble>
      <RestTabInner
        onClick={props.onClick}
        isSelected={isSelected}
        opacity={opacity}
      >
        {no ? `REST ${no}` : 'VŠE'}
      </RestTabInner>
      {no ? (
        <div
          style={{
            position: 'absolute',
            right: 4,
            top: 0,
            height: '100%',
            width: 7,
            backgroundColor: fullfillmentToColor(tabState),
            opacity,
          }}
        />
      ) : null}
      {!isSelected || small ? null : <RestTabTriangle />}
    </RestTabOuter>
  )
}

const RestTabs = (
  {
    gender,
    onTabSwitch = () => undefined,
    selectedTab,
    tabStates = [],
    comments = [],
    names = [],
    small = false,
  } = {},
) => (
  <div style={{ textAlign: 'center', transition }}>
    {Array(10)
      .fill(0)
      .map((v, i) => i)
      .map(i => (
        <RestTab
          small={small}
          key={i}
          no={i}
          onClick={() => onTabSwitch(i)}
          isSelected={selectedTab === i}
          tabState={tabStates[i]}
          comment={comments[i]}
          name={names[i - 1]}
          gender={gender}
        />
      ))}
  </div>
)

const HCenter = ({ children }) => (
  <div
    style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}
  >
    {children}
  </div>
)

const ArrowLeftColumn = ({ person, rotate }) => (
  <div
    style={{
      display: 'inline-block',
      verticalAlign: 'middle',
      color: colors.grey,
      position: 'relative',
      marginTop: 40,
      transform: rotate ? 'translate(-5px, 15px)' : 'translate(-15px, 0px)',
      transition,
    }}
  >
    <div style={{ position: 'absolute', left: 0 }}>
      {person.type === 'MOP' ? '50%' : '75%'}
    </div>
    <div style={{ width: 100, height: 85, position: 'relative' }}>
      <svg
        width="272px"
        height="226px"
        viewBox="0 0 136 113"
        style={{
          position: 'absolute',
          left: -86,
          top: -70,
          transform: rotate ? 'rotate(-30deg)' : undefined,
          transition,
        }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={colors.grey}
          d="M65.03,53.71l9.37,1.46c-1.03,2.4-1.33,4.28-2.15,5.44
                c6.23-2.88,13.28-6.91,20.31-10.93l-18.4-13.02c-0.3,1.86,0.55,4.53,0.78,7.1c-5.7-0.24-26.91,0.92-29,13.36l-2.32,13.8
                c0.31,1.99-0.11,4.52,0.19,6.51C44.66,72.38,50.71,51.47,65.03,53.71z"
        />
      </svg>
    </div>
  </div>
)

const ArrowRightColumn = ({ person, rotate }) => (
  <div
    style={{
      display: 'inline-block',
      verticalAlign: 'middle',
      color: colors.grey,
      position: 'relative',
      marginTop: 40,
      transform: rotate ? 'translate(5px, 15px)' : 'translate(15px, 0px)',
      transition,
    }}
  >
    <div style={{ position: 'absolute', right: 0 }}>
      {person.type === 'MOP' ? '50%' : '25%'}
    </div>
    <div
      style={{
        width: 100,
        height: 85,
        position: 'relative',
        transform: rotate ? 'rotate(30deg)' : undefined,
        transition,
      }}
    >
      <svg
        width="272px"
        height="226px"
        viewBox="0 0 136 113"
        style={{ position: 'absolute', left: -86, top: -70 }}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill={colors.grey}
          d="m 71.13,53.71 -9.37,1.46 c 1.03,2.4 1.33,4.28 2.15,5.44 C 57.68,57.73 50.63,53.7 43.6,49.68 L 62,36.66 c 0.3,1.86 -0.55,4.53 -0.78,7.1 5.7,-0.24 26.91,0.92 29,13.36 l 2.32,13.8 c -0.31,1.99 0.11,4.52 -0.19,6.51 C 91.5,72.38 85.45,51.47 71.13,53.71 Z"
        />
      </svg>
    </div>
  </div>
)

const GraphSection = ({
  header,
  person,
  data,
  fullfillment,
  gender,
  small,
}) => {
  const colStyle = {
    width: '50%',
    height: 300,
    position: 'relative',
    display: 'inline-block',
    transition,
  }
  return (
    <div
      style={{
        textAlign: 'center',
        paddingTop: 20,
        transition,
      }}
    >
      <div>
        <h2>{header}</h2>
      </div>
      <div style={{ height: '3em', marginTop: -25, position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          {(() => {
            const text = fullfillmentToText(fullfillment, gender)
            if (text) return text
            if (fullfillment)
              return (
                <span>
                  {fullfillment.replace(
                    'porušil',
                    gender === 'M' ? 'porušil' : 'porušila',
                  )}
                  <svgs.PanacekNoSupport />
                </span>
              )
            return gender === 'M' ? 'Nezavázal se' : 'Nezavázala se'
          })()}
        </div>
      </div>
      <div>
        {/* center chart */}
        <div style={{ width: '100%', overflow: 'hidden' }}>
          <ArrowLeftColumn person={person} rotate={small} />
          <div
            style={{
              display: 'inline-block',
              verticalAlign: 'middle',
              marginTop: 15,
            }}
          >
            <PieChart
              data={data && data.total}
              gender={person.gender}
              title="Celkově"
            />
          </div>
          <ArrowRightColumn person={person} rotate={small} />
        </div>
      </div>
      <div style={{ height: 170 }}>
        {/* left chart */}
        <div
          style={{ ...colStyle, transform: small ? '' : 'translateX(-50px)' }}
        >
          <HCenter>
            <PieChart
              data={data && data.voting}
              gender={person.gender}
              title="Hlasování"
            />
          </HCenter>
        </div>
        {/* right chart */}
        <div
          style={{ ...colStyle, transform: small ? '' : 'translateX(50px)' }}
        >
          <HCenter>
            <ActivityChart data={data && data.activity} />
          </HCenter>
        </div>
      </div>
    </div>
  )
}

const PoliticianChartTabs = props => {
  const { visibleRest, setVisibleRest, pledge, person, small } = props
  const data = props[props.visibleRest ? `rest${visibleRest}` : 'all']
  return (
    <div>
      <RestTabs
        gender={person.gender}
        selectedTab={visibleRest}
        onTabSwitch={setVisibleRest}
        tabStates={pledge.fullfillment}
        comments={pledge.comments}
        small={small}
        names={new Array(9)
          .fill(0)
          .map((v, i) => props[`rest${i + 1}`].restName)}
      />
      <GraphSection
        small={small}
        gender={person.gender}
        data={data}
        person={props.person}
        header={visibleRest ? data.restName : 'Hodnocení za všechny zákony'}
        fullfillment={pledge.fullfillment[visibleRest]}
      />
    </div>
  )
}
export default PoliticianChartTabs



// WEBPACK FOOTER //
// ./components/PoliticianDetail/PoliticianChartTabs.js